<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	
	export default {
		name: 'App',
		mounted() {
		}
	}
</script>

<style>
	#app {}
	.el-menu .msg_card_body_mark {
		transform: scale(0.8, 0.8);
		margin-top: -8px;
		margin-left: 5px;
	}
	.el-menu .el-badge__content{
		border: 0px;
	}
	.el-notification{
		cursor:pointer;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue